import layout from "../layouts/layout.vue";

// nav false 路由表， true 菜单表
export const filterAsyncRouter = (asyncRouterMap: any[], nav = false) => {
    return asyncRouterMap.filter((route) => {

        if (!nav && route.component == 'Layout' && !route.children.length) {
            route.children = [
                {
                    ...route,
                    component: route.path,
                    name: route.name + route.path
                }
            ]
        }
        if (nav) {
            filterChildren(route.children, route)
        }
        try {
            if (route.component) {
                // Layout ParentView 组件特殊处理
                if (route.component === "Layout") {
                    route.component = layout;
                } else if (route.component.indexOf(':') !== -1) {

                    const path = route.component.split(':').join('');
                    route.component = loadView(path);
                } else if (route.component.indexOf('/') !== -1) {
                    route.component = loadView(route.component);
                }
            }
        } catch (err) {
        }
        if (route.children != null && route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children, nav);
        }
        return true;
    });
}

export const filterChildren = (childrenMap: any[], lastRouter: any) => {
    let children: any = [];
    childrenMap.forEach((el, index) => {
        if (el.children && el.children.length) {
            if (el.component === "ParentView") {
                el.children.forEach((c) => {
                    c.path = el.path + "/" + c.path;
                    if (c.children && c.children.length) {
                        children = children.concat(filterChildren(c.children, c));
                        return;
                    }
                    children.push(c);
                });
                return;
            }
        }
        if (lastRouter) {
            el.path = lastRouter.path + "/" + el.path;
        }
        children = children.concat(el);
    });
    return children;
}
export const loadView = (view: string) => {
    // 路由懒加载

    let com = null

    let modules = import.meta.glob('@/views/**/*.vue')
    try {
        const src = `/src/views${view}/index.vue`
        com = modules[src];

    } catch (err) {

    }
    return com
};